<script setup lang="ts"></script>

<template>
  <UiSection
    id="benefit-systems-pillars"
    class="section-pillars"
    color="psychology"
  >
    <UiHeader
      position="center"
      :header="$t('strategy.pillars.header')"
      :subheader="$t('strategy.pillars.text')"
    />

    <picture>
      <source
        media="(width < 1200px)"
        srcset="/images/strategy/benefit-systems-pillars_m.webp"
      >
      <source
        media="(width >= 1200px)"
        srcset="/images/strategy/benefit-systems-pillars.webp"
      >
      <img
        width="100%"
        src="/images/strategy/benefit-systems-pillars.webp"
        :alt="$t('strategy.pillars.header')"
      >
    </picture>

    <div class="section__container">
      <div class="pillars-cards">
        <div class="pillars-card">
          <h3 class="pillars-card__label pillars-card__label--environmental">
            <i>E</i>{{ $t('strategy.pillars.e.label') }}
          </h3>

          <p class="pillars-card__text">
            {{ $t('strategy.pillars.e.text') }}
          </p>
        </div>

        <div class="pillars-card">
          <h3 class="pillars-card__label pillars-card__label--social">
            <i>S</i>{{ $t('strategy.pillars.s.label') }}
          </h3>

          <p class="pillars-card__text">
            {{ $t('strategy.pillars.s.text') }}
          </p>
        </div>

        <div class="pillars-card">
          <h3 class="pillars-card__label pillars-card__label--governance">
            <i>G</i>{{ $t('strategy.pillars.g.label') }}
          </h3>
          
          <p class="pillars-card__text">
            {{ $t('strategy.pillars.g.text') }}
          </p>
        </div>
      </div>
    </div>
  </UiSection>
</template>

<style lang="scss" scoped>
:deep(.ui-header__subheader) {
  margin-bottom: 3.2rem;
}

.section-pillars {
  background-color: $psychology-100;
}

.pillars-cards {
  display: flex;
  gap: 1.4rem;
  margin-top: 2.4rem;
  overflow-x: scroll;
}

.pillars-card {
  flex: 1;
  min-width: 80%;
  padding: 2rem;
  background-color: $white;
  border-radius: 1.6rem;

  &__label {
    @include body-2;
    margin-bottom: 2rem;

    i {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 3.2rem;
      height: 3.2rem;
      margin-right: 1rem;
      border-radius: 50%;
    }

    &--environmental {
      color: $color-environmental;

      i {
        background-color: $color-environmental-bg;
      }
    }

    &--social {
      color: $color-social;

      i {
        background-color: $color-social-bg;
      }
    }

    &--governance {
      color: $color-governance;

      i {
        background-color: $color-governance-bg;
      }
    }
  }

  &__text {
    @include body-1;
  }
}

@include atM {
  :deep(.ui-header__subheader) {
    margin-bottom: 9rem;
  }

  .pillars-cards {
    margin-top: -12rem;
    overflow-x: auto;
  }

  .pillars-card {
    min-width: unset;
    padding: 4rem;

    &__label {
      @include h9;
      margin-bottom: 4rem;

      i {
        width: 4.8rem;
        height: 4.8rem;
        margin-right: 1.6rem;
      }
    }

    &__text {
      @include h9;
    }
  }
}
</style>
